import { customerService } from '../../services'

// initial state
const state = () => ({
  customers: [],
  customer: null,
  status: {},
})

// actions
const actions = {
  getCustomers({ commit }) {
    commit('waitResponse');
    customerService.getCustomers()
      .then(
        customers => {
          commit('customersSuccess', customers);
        },
        error => {
          commit('customersFailure', error);
        }
      );
  },
  getCustomer({ commit }, customerId) {
    customerService.getCustomer(customerId)
      .then(
        customer => {
          commit('customerSuccess', customer);
        },
        error => {
          commit('customerFailure', error);
        }
      );
  },
  createCustomer({ commit }, customerData) {
    customerService.createCustomer(customerData)
      .then(
        customer => {
          commit('customerSuccess', customer);
        },
        error => {
          commit('customerFailure', error);
        }
      );
  },
  editCustomer({ commit }, {customerId, customerData}) {
    customerService.editCustomer(customerId, customerData)
      .then(
        customer => {
          commit('customerSuccess', customer);
        },
        error => {
          commit('customerFailure', error);
        }
      );
  },
  deleteCustomer({ commit }, customerId) {
    customerService.deleteCustomer(customerId)
      .then(
        customer => {
            commit('customerDelete', customer.id);
          },
          error => {
            commit('customerFailure', error);
          }
      );
  },
  syncCustomers({ commit }) {
    commit('waitResponse');
    customerService.syncCustomers()
      .then(
        customers => {
          commit('customersSuccess', customers);
        },
        error => {
          commit('customersFailure', error);
        }
      );
  },
}

// mutations
const mutations = {
  waitResponse(state) {
    state.status = { isWaiting: true };
  },
  customersSuccess(state, customers) {
    state.customers = customers
    state.status = {};
  },
  customersFailure(state, error) {
    console.log(state, error);
    state.status = {};
  },
  customerSuccess(state, customer) {
    state.customer = customer;
    state.status = {};
  },
  customerFailure(state, error) {
    console.log(state, error);
    state.status = {};
  },
  customerDelete(state, customerId) {
    let index = state.customers.findIndex(customer => customer.id == customerId);
    state.customers.splice(index, 1);
    state.status = {};
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
